import { useDonationFormContext } from '@web/components/page-components/DonationForm'
import { useVirtualGiftSection } from '@web/components/page-components/VirtualGiftSection/VirtualGiftSectionProvider'
import { usePageStore } from 'apps/fe-donation/libs/hooks/usePageStore'
import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

const VirtualGiftSectionHandler = () => {
  const { quantity, settings, items: giftItems, step: virtualGiftStep, setStep } = useVirtualGiftSection()
  const searchParams = useSearchParams()
  const virtualGiftCustomFields = useDonationFormContext((state) => {
    const fields = state.settings.extraFields.filter((field) => field.customField?.name?.startsWith('_VirtualGift'))
    return {
      quantityField: fields.find((field) => field.customField?.name?.endsWith('Quantity')),
      amountField: fields.find((field) => field.customField?.name?.endsWith('Amount')),
      detailsField: fields.find((field) => field.customField?.name?.endsWith('Details')),
      typeField: fields.find((field) => field.customField?.name?.endsWith('Type')),
    }
  })
  const donationFormStep = useDonationFormContext((state) => state.step)
  const { setFormValues, setStep: setDonationFormStep } = useDonationFormContext((state) => state.actions)

  useEffect(() => {
    // update donation form amount based on gift selection
    const amount = Array.from({ length: quantity }, (_, i) => i).reduce((acc, curr) => {
      const items = settings.styles?.options?.items
      // grab the value for the current item or default to the first value
      return acc + (items?.[curr]?.value || items?.[0]?.value || 0)
    }, 0)

    usePageStore.setState({ amount })
    setFormValues({
      amount,
      extraFields: {
        [virtualGiftCustomFields.quantityField?.customField?.id || 'virtualGiftQuantity']: `${quantity}`,
        [virtualGiftCustomFields.amountField?.customField?.id || 'virtualGiftAmount']: `${amount}`,
      },
    })
  }, [quantity])

  useEffect(() => {
    // update form custom fields with gift details
    if (!giftItems[0]) {
      return
    }

    setFormValues({
      extraFields: {
        [virtualGiftCustomFields.detailsField?.customField?.id || 'virtualGiftDetails']: JSON.stringify(
          giftItems.map((item) => item.value).flat(),
        ),
        [virtualGiftCustomFields.typeField?.customField?.id || 'virtualGiftType']: settings.styles?.options?.name || '',
      },
    })
  }, [giftItems])

  useEffect(() => {
    // reset the donation form any time we go back
    if (donationFormStep === 0) {
      return
    }

    setDonationFormStep(0)
  }, [virtualGiftStep])

  useEffect(() => {
    // on load if there is an add_to_cart param, skip to the next step
    if (searchParams.get('add_to_cart') === 'true') {
      setStep(1)
    }
  }, [])

  return null
}

export default VirtualGiftSectionHandler
